<template>
  <FilterMenuComponent
    ref="filterMenuRef"
    v-model="filterStore.currentPortfolio"
    :items="portfolioItems"
    :search-string-callback="(item) => item.value.queryString"
    teleport
    use-cards
    :item-height="showAssets ? 96 : 48"
    :item-spacing="16"
    @confirmed="onPortfolioSelection"
  >
    <span v-if="filterStore.currentPortfolio" class="truncate">
      {{ filterStore.currentPortfolio.displayName }}
    </span>
    <span v-else class="text-primary-200">Kies een portfolio</span>
    <template #title> Portfolio's </template>
    <template
      v-for="portfolio in meteringPointsStore.portfolios"
      :key="portfolio.id"
      #[portfolio.displayName]
    >
      <div class="w-full">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2 truncate">
            <BaseIcon name="briefcase-4" filled class="flex-shrink-0 text-lg" />
            <TextLabel class="truncate">{{ portfolio.displayName }}</TextLabel>
          </div>
          <span
            v-if="showAssets && portfolioAssets(portfolio)"
            class="flex-shrink-0 text-sm text-gray-400"
          >
            {{ portfolioAssets(portfolio).length }}
            installatie{{ portfolioAssets(portfolio).length !== 1 ? "s" : "" }}
          </span>
        </div>
        <AssetsBarComponent
          v-if="showAssets && portfolioAssets(portfolio)"
          :assets="portfolioAssets(portfolio)"
          class="-mx-3 mt-2 px-3 text-gray-900"
        />
      </div>
    </template>
  </FilterMenuComponent>
</template>

<script setup>
import { ref, computed } from "vue"
import { triggerEvent } from "@/services/plausibleService.js"
import useMeteringPointsStore from "@/stores/repower/meteringPointsStore.js"
import useFilterStore from "@/stores/filterStore.js"
import { BaseIcon, TextLabel } from "@repowerednl/ui-component-library"
import FilterMenuComponent from "@/components/input/FilterMenuComponent.vue"
import AssetsBarComponent from "@/components/navigation/AssetsBarComponent.vue"

const filterMenuRef = ref()
const meteringPointsStore = useMeteringPointsStore()
const filterStore = useFilterStore()

const showAssets = computed(() => !meteringPointsStore.loading)

const portfolioItems = computed(() =>
  meteringPointsStore.portfolios.map((portfolio) => {
    return {
      label: portfolio.displayName,
      value: portfolio,
    }
  }),
)

function onPortfolioSelection(selectedPortfolio) {
  if (!selectedPortfolio?.id) {
    triggerEvent("portfolio-select:none")
    return
  }
  triggerEvent("portfolio-select:selected")
  filterStore.setMeteringPoint(selectedPortfolio)
}

function portfolioAssets(portfolio) {
  return meteringPointsStore.assetsByPortfolio[portfolio.id]
}

defineExpose({
  openMenu() {
    filterMenuRef.value.openMenu()
  },
})
</script>
